import { attachToFF8Form, attachToAllCompatibleForms } from "./form-attachment";
import { logger } from "./logger";
import { setupSourceBuster } from "./setup-source-buster";
import { captureErrorAsync } from "./../utils/capture-error-async";
import { analyticsReady } from "../utils/ready";
import { setAnalyticsContext } from "../utils/analytics";
import { TrafficInfo } from "./types";
import { persistAttributionParams } from "./ad-attribution";

type Variables = Record<string, never>;

function setTrafficInfoInAnalyticsContext(trafficInfo: TrafficInfo) {
  setAnalyticsContext({
    campaign: {
      name: trafficInfo.campaign,
      source: trafficInfo.source,
      medium: trafficInfo.medium,
      content: trafficInfo.content,
      term: trafficInfo.term,
    },
  });
}

async function analyticsIdentify(trafficInfo: TrafficInfo) {
  await analyticsReady();

  setTrafficInfoInAnalyticsContext(trafficInfo);

  analytics.identify({ trafficInfo }, window.analytics._defaultContext);
}

function afterCookiesSetup(trafficInfo: TrafficInfo) {
  try {
    attachToAllCompatibleForms(trafficInfo);
  } catch (e) {
    logger.error("Could not attach to compatible form (%s)", e.message);
    captureErrorAsync(e);
  }

  try {
    attachToFF8Form(trafficInfo);
  } catch (e) {
    logger.error("Could not attach to FF8 contact form (%s)", e.message);
    captureErrorAsync(e);
  }

  try {
    analyticsIdentify(trafficInfo);
  } catch (e) {
    captureErrorAsync(e);
  }
}

export function install(_: Variables): Promise<void> {
  setupSourceBuster(afterCookiesSetup);
  return persistAttributionParams();
}
